import {createContext,useContext} from 'react';

export const I18nContext = createContext<any>(null);

export function useI18n() {
    const { i18n, setI18n, locale } = useContext(I18nContext);
    return { i18n, setI18n, locale };
  }